import { makeUseAnalytics } from '@plato/app-core/hooks/make-use-analytics';
import type { UiFilterVisibility } from '@plato/ui-legacy/components/filters/types/ui-filter-visibility';
import type { ExplainableMetric } from './use-metric-copy.ts';

type FilterViewEvent = {
    view_id: string;
    view_key: string;
};

type FilterViewVisibilityEvent = FilterViewEvent & {
    visibility: UiFilterVisibility;
};

export type SharedAnalyticsEvents = {
    metric_hint_opened: {
        metric: ExplainableMetric;
    };
    filter_view_created: FilterViewVisibilityEvent;
    filter_view_updated: FilterViewVisibilityEvent;
    filter_view_applied: FilterViewVisibilityEvent;
    filter_view_modified: FilterViewVisibilityEvent & {
        modified_keys: string[];
    };
    filter_view_deleted: FilterViewEvent;
};

export const useAnalytics = makeUseAnalytics<SharedAnalyticsEvents>();
